if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    let timeHeader = 2;
    let $barHeader, isPauseHeader, tickHeader, percentTimeHeader, $sliDerHeader;

    $barHeader = $('.slider-progress-header .progress');
    $sliDerHeader = $('.sym-slides');

    let time = 2;
    let $bar, isPause, tick, percentTime, $sliDer;

    $bar = $('.slider-progress .progress');
    $sliDer = $('.slider-bg-content');

    $('.sym-slides').slick({
        accessibility: false
    });

    $('.images-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        accessibility: true
    });

    $('.slider-bg-content').slick({
        arrows: true,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.reviews-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    adaptiveHeight: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    dots: false,
                }
            }
        ]
    });

    $('.gallery-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        accessibility: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots: false,
                }
            }
        ]
    });

    $('.slider-rooms-content').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    //Progressbar Header
    function startProgressbarHeader() {
        resetProgressbarHeader();
        percentTimeHeader = 0;
        isPauseHeader = false;
        tickHeader = setInterval(intervalHeader, 40);
    }

    function intervalHeader() {
        if (isPauseHeader === false) {
            percentTimeHeader += 1 / (timeHeader + 0.1);
            $barHeader.css({
                width: percentTimeHeader + "%"
            });
            if (percentTimeHeader >= 100) {
                $sliDerHeader.slick('slickNext');
                startProgressbarHeader();
            }
        }
    }

    function resetProgressbarHeader() {
        $barHeader.css({
            width: 0 + "%"
        });
        clearTimeout(tickHeader);
    }

    startProgressbarHeader();

    $('.sym-slides .slick-next, .sym-slides .slick-prev, .sym-slides .slick-dots button').click(function() {
        startProgressbarHeader();
    });

    //Progressbar Slider
    function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        isPause = false;
        tick = setInterval(interval, 40);
    }

    function interval() {
        if (isPause === false) {
            percentTime += 1 / (time + 0.1);
            $bar.css({
                height: percentTime + "%"
            });
            if (percentTime >= 100) {
                $sliDer.slick('slickNext');
                startProgressbar();
            }
        }
    }

    function resetProgressbar() {
        $bar.css({
            height: 0 + '%'
        });
        clearTimeout(tick);
    }

    startProgressbar();

    $('.slider-bg-content .slick-next, .slider-bg-content .slick-prev, .slider-bg-content .slick-dots button').click(function() {
        startProgressbar();
    });

    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    //FAQ
    setTimeout(function(){
        $('.tab-label').each(function(){
            let thisHeightTap = $(this).height() + 40;
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeightTap + 'px'},400);
            if($(this).hasClass('open')){
                $(this).parent().animate({height: thisHeight + 'px'},400);
            }
        });
        $('.learn-more-btn').append('<div class="arrow"></div>');
    }, 400);

    $('.tab-label').click(function(){
        let currentclick = $(this);
        let thisHeightTap = $(this).height() + 40;

        let slideIndex = $(this).data('artwork');
        $(".accordion-slide").slick('slickGoTo', parseInt(slideIndex));

        if(!currentclick.hasClass('open')){
            $('.tab-label').each(function(){
                if($(this) !== currentclick ){
                    if($(this).hasClass('open')){
                        let thisHeight = $(this).height() + 40;
                        $(this).removeClass('open');
                        $(this).parent().animate({height: thisHeight + 'px'},400);
                    }
                }
            });
            currentclick.addClass('open');
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeight + 'px'},400);
        } else {
            currentclick.removeClass('open');
            currentclick.parent().animate({height: thisHeightTap + 'px'},400);
        }
    });

    $('[data-fancybox]').fancybox({
        loop : true,
        backFocus: false,
        autoFocus: false,
    });

    $("a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a.accordion-toggle, a#js_btn_book))").click(function(e){
        e.preventDefault();
        let strAncla = $(this).prop('hash').substr(1);
        animateto(strAncla);
    });

    $("input[name*=select_destination]").eq(0).attr("checked", "checked");

    $('.btn:not(.attractions-map__expand), .signup-btn').each(function() {
        let htmlString = $(this).text();
        $(this).html('<span>'+htmlString+'</span>');
    });

    //** Function  Anchor link form */
    let errMsg2022 = document.querySelector( "#errMsg-2022" );
    if( errMsg2022 ){ 
        let formSibling = errMsg2022.nextElementSibling;
        formSibling.addEventListener( 'submit', () => {
            setInterval( () => {
            
                let showing = errMsg2022.style.display
                if( showing != "none" )
                    errMsg2022.classList.add('hidden');
                    window.location.href = '/thank-you';
    
            }, 1 )    
        } );
        /*let showing = errMsg2022.style.display
        console.log(showing,'here!')
        if(showing != "none" ){
            errMsg2022.classList.add('hidden')
            
        }*/
    }

    //* End function *//

    
    /*MOBILE MENU NAV
	****************************************************************/

    //Open Navigation
    $('#menu-btn').click(function(event) {
        $('html').addClass('hide-overflow');
        $('.navigation').addClass('open');
        $('.navigation').stop().animate({left:'0px'},{duration:300});
        if($('.navigation ul li a').hasClass('.item-open')){
            $(".item-open").get(0).scrollIntoView(false);
        }
    });

    $('.close-menu').click(function(event) {
        event.preventDefault();
        $('html').removeClass('hide-overflow');
        $('.navigation').removeClass('open');
        $('.navigation').stop().animate({left:'100%'},{queue:false,duration:300});
    });

    //SUBNAVIGATION

    // Open active sub-nav on load
    $('.navigation ul.submenu li .active').closest('.inner').addClass('open')
    $('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
    $('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, function() {}).addClass('menu-open');

    //Toggle open/close on tap
    $('.navigation li a').off('click').on('click', function(event) {
        if ( $(this).parent().children(".sub-sub-menu").length > 0 ) {

            event.preventDefault();

            if ($(this).next().hasClass('menu-open')) {
                $(this).closest('.inner').removeClass('open');
                $('.navigation ul li').removeClass('item-open');
                $(this).parent().addClass('item-open');
                $(this).next().slideUp(300, function(){
                    if($('.navigation ul li a').hasClass('active')){
                        $(".item-open").get(0).scrollIntoView(false);
                    }
                }).removeClass('menu-open');
            } else {
                $(this).closest('.inner').addClass('open');
                $('.navigation ul li').removeClass('item-open');
                $(this).parent().addClass('item-open');
                $('.sub-sub-menu.menu-open').slideUp(300).removeClass('menu-open');
                $(this).next().addClass('menu-open').slideDown(300, function(){
                    if($('.navigation ul li a').hasClass('active')){
                        $(".item-open").get(0).scrollIntoView(false);
                    }
                });
            }
        }
    });

    let screenHeight = $(window).height();
    $('#home .top-img figure, #home .top-img video').css("height", screenHeight);

    $(window).resize(function(){
        screenHeight = $(window).height();
        $('#home .top-img figure, #home .top-img video').css("height", screenHeight);
    });



    if (document.querySelector("#arriveInput")) {

        let arriveInputBooking = document.querySelector("#arriveInput-booking");
        
        flatpickr(arriveInputBooking, {
            dateFormat: "Y-m-d", 
            onChange: function(selectedDates, dateStr, instance) {
        
                let initDate = dateStr;
                document.querySelector("[name=qCiD]").value = initDate;
        
        
                let departureDate = new Date(selectedDates[0]);
                departureDate.setDate(departureDate.getDate());
                let departureDateStr = departureDate.toISOString().split('T')[0];
        
        
                if (document.querySelector("#departureInput-booking")._flatpickr) {
                    document.querySelector("#departureInput-booking")._flatpickr.setDate(departureDateStr);
                    document.querySelector("#departureInput-booking")._flatpickr.set('minDate', departureDateStr);
                }
                document.querySelector("#departureInput-booking").value = departureDateStr;

                let dayFormatedToBW = parseInt(departureDateStr.split('-')[2]);
                let monthYearFormatedToBW = parseInt(departureDateStr.split('-')[1])+''+departureDateStr.split('-')[0];

                document.querySelector('#BookLanding input[name="qCiD"]').value = dayFormatedToBW;
                document.querySelector('#BookLanding input[name="qCiMy"]').value = monthYearFormatedToBW;
                document.querySelector('#BookLanding input[name="qCoD"]').value = dayFormatedToBW;
                document.querySelector('#BookLanding input[name="qCoMy"]').value = monthYearFormatedToBW;
            }
        });
        }
        
        if (document.querySelector("#departureInput-booking")) {
        
            let departureInputBooking = document.querySelector("#departureInput-booking");
        
            flatpickr(departureInputBooking, {
                dateFormat: "Y-m-d", 
                onChange: function(selectedDates, dateStr, instance) {
                    
                    let departureDate = new Date(selectedDates[0]);
                    departureDate.setDate(departureDate.getDate());
                    let departureDateStr = departureDate.toISOString().split('T')[0];

                    let dayFormatedToBW = parseInt(departureDateStr.split('-')[2]);
                    let monthYearFormatedToBW = parseInt(departureDateStr.split('-')[1])+''+departureDateStr.split('-')[0];

                    document.querySelector('#BookLanding input[name="qCoD"]').value = dayFormatedToBW;
                    document.querySelector('#BookLanding input[name="qCoMy"]').value = monthYearFormatedToBW;

                }
            });
        }


})();

function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}